import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Button,
  Card,
  CardContent,
  Grid2,
  IconButton,
  Typography,
  Box,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TablePagination,
} from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Grid from "@mui/material/Grid";
import "./dashboard.css";
import MaterialButton from "../../../components/MaterialButton";
import axios from "axios";
import moment from "moment";
import BASEURL from "../../Utils/Baseurl";
import { Doughnut } from "react-chartjs-2";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import MiniCard from "../MiniCard";
import { useDispatch, useSelector } from "react-redux";
import {
  checkIn,
  checkOut,
  setcheckInTime,
  setcheckOutTime,
} from "../../../Redux/reducers/timerSlice";

// Register the required components
ChartJS.register(ArcElement, Tooltip, Legend);
const Mangerdashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isCheckedIn, checkInTime, checkOutTime } = useSelector(
    (state) => state.timer
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [dor, setDor] = useState([]);
  const data = sessionStorage.getItem("user");
  const parsedData = JSON.parse(data);

  const [stsTabel, setStsTable] = useState(false);
  const [birthday, setbirthday] = useState([]);
  const [birthpopup, setBirthdayPopup] = useState(false);
  const [dates, setData] = useState({});
  const [leaveCount, setLeaveCount] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [teams, setTeams] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [displayTime, setDisplayTime] = useState("00:00:00");
  const intervalRef = useRef(null);
  const startTimeRef = useRef(null);
  const baseSecondsRef = useRef(0);
    const [ischeckIn,setisCheckIn] = useState(false)

  useEffect(() => {
    getleave();
    fetchEmployeeDor();
    handeldatas();
    leavecount();
    fetchAttendanceData();
  }, []);

  //checkin checkout logic useffect
  useEffect(() => {
    handleCheck(); // on mount

    return () => stopTimer(); // cleanup
  }, []);

  useEffect(() => {
    handleCheck(); // initial load
    const syncInterval = setInterval(handleCheck, 5 * 60 * 1000); // 5 min
    return () => clearInterval(syncInterval);
  }, []);

  useEffect(() => {
    window.addEventListener("online", handleCheck);
    return () => {
      window.removeEventListener("online", handleCheck);
    };
  }, []);

  //checkin checkout logic end useffect

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleClockOut = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to clock out?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        // onEmployeeeSubmit();
        handleCheckIn();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const [totalLeaveCount, settotalLeaveCount] = useState(0);

  const getleave = async () => {
    let query = `query leavedetailbyme($id:String!){
      leaveDetailsByMe(id: $id){
        user{
          email
        }
        status
        takedLeave
        leaveType {
          id
          name
        }
        leaveCount
        workFromHome
      }
    }`;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query,
          variables: { id: parsedData?.id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data.leaveDetailsByMe;

      let filterdata = result.filter(
        (item) =>
          item?.leaveType?.name !== "loss_of_pay" &&
          item?.leaveType?.name !== "paternity_leave" &&
          item?.leaveType?.name !== "maternity_leave" &&
          item?.leaveType?.name !== "work_from_home"
      );

      let totalLeaveCounts = filterdata.reduce((acc, val) => {
        return acc + (val.leaveCount || 0);
      }, 0);

      let totaltakedLeaveCounts = filterdata.reduce((acc, val) => {
        return acc + (val.takedLeave || 0);
      }, 0);

      let finalresult = totalLeaveCounts - totaltakedLeaveCounts;

      settotalLeaveCount(finalresult);
    } catch (error) {
      console.error("errorssss:", error.message);
    }
  };

  //checkin checkout logic and functions
  const handleCheckIn = async () => {
    const data = sessionStorage.getItem("user");
    const parsedData = JSON.parse(data);

    const queryCheckIn = `mutation CheckIn($id: String!) {
  checkInUpdate(id: $id) {
    success
    message
    error
    set
    checkin {
      id
      user {
        id
        firstName
        lastName
      }
      checkIn
      checkOut
      totalWorkingHours
      overtime
    }
  }
}`;
    const queryCheckOut = `mutation CheckOut($id: String!) {
  checkOutTime(id: $id) {
    success
    message
    error
    set
    checkout {
      id
      user {
        id
        firstName
        lastName
      }
      checkIn
      checkOut
      totalWorkingHours
      overtime
    }
  }
}`;

    if (ischeckIn) {
      // Clock-Out logic
      try {
        const response = await axios.post(BASEURL, {
          query: queryCheckOut,
          variables: { id: parsedData?.id }, // Ensure `id` is valid and exists
        });

        console.log("Check-Out Response:", response.data);

        if (response.data.errors) {
          Swal.fire({
            title: response.data.errors[0].message,
            showConfirmButton: true,
            timer: 2500,
          });
          console.error("Check-Out Error:", response.data.errors[0].message);
          return; // Exit if there's a server-side error
        }
setisCheckIn(false)
        dispatch(checkOut());
        dispatch(setcheckOutTime(data?.checkOut));
      } catch (error) {
        console.error("Error during Check-Out:", error.message);
      }
    } else {
      // Clock-In logic
      try {
        const response = await axios.post(BASEURL, {
          query: queryCheckIn,
          variables: { id: parsedData?.id },
        });

        const graphqlError = response?.data?.errors?.[0]?.message;
        const checkInData = response?.data?.data?.checkInUpdate;

        if (graphqlError || checkInData?.error || checkInData?.success === false) {
          const errorMessage =
            graphqlError ||
            checkInData?.message ||
            "Check-in could not be completed.";

          Swal.fire({
            icon: "warning",
            title: "Check-In Unavailable",
            html: `
              <div style="
                font-size: 14px;
                color: #64748B;
                line-height: 1.6;
                margin-top: 8px;
              ">
                ${errorMessage}
              </div>
            `,
            confirmButtonText: "Okay",
            confirmButtonColor: "#2563EB",
            buttonsStyling: true,
            customClass: {
              popup: "checkin-alert-popup",
              title: "checkin-alert-title",
              confirmButton: "checkin-alert-button",
            },
            showCloseButton: true,
            allowOutsideClick: false,
            timer: 4000,
            timerProgressBar: true,
          });

          console.error("Check-In Error:", errorMessage);
          return;
        }

        dispatch(checkIn());

        dispatch(
          setcheckInTime(
            checkInData?.checkin?.checkIn
          )
        );

        handleCheck(true);

      } catch (error) {
        console.error("Error during Check-In:", error.message);

        Swal.fire({
          icon: "error",
          title: "Something Went Wrong",
          text: "Unable to complete check-in. Please try again.",
          confirmButtonText: "Okay",
          confirmButtonColor: "#2563EB",
        });
      }
    }
  };

  const handleCheck = async () => {
    const data = sessionStorage.getItem("user");
    const parsedData = JSON.parse(data);

    const queryCheckIn = `
    query GetLatestBiometricAttendance($userId: ID!) {
      latestBiometricAttendanceByUser(userId: $userId) {
        id
        checkIn
        checkOut
        totalWorkingHours
        overtime
        resumeTime
      }
    }
  `;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: queryCheckIn,
          variables: { userId: parsedData?.id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response?.data?.data?.latestBiometricAttendanceByUser;

      if (data && data.checkOut === null) {
        const resumeSeconds = parseTimeToSeconds(data.resumeTime || "00:00:00");

        // Save base resume seconds and start time (in ms)
        baseSecondsRef.current = resumeSeconds;
        startTimeRef.current = Date.now();
setisCheckIn(true)
        startAccurateTimer();
      } else {
        stopTimer();
        setisCheckIn(false)
        setDisplayTime("00:00:00");
      }
    } catch (error) {
      console.error("Error during Check-In:", error.message);
    }
  };

  const parseTimeToSeconds = (timeStr) => {
    const [h, m, s] = timeStr.split(":").map(Number);
    return h * 3600 + m * 60 + s;
  };

  // Format seconds → "HH:MM:SS"
  const formatTime = (seconds) => {
    const h = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${h}:${m}:${s}`;
  };

  const startAccurateTimer = () => {
    stopTimer();
    intervalRef.current = setInterval(() => {
      const now = Date.now();
      const elapsed = Math.floor((now - startTimeRef.current) / 1000);
      const total = baseSecondsRef.current + elapsed;
      setDisplayTime(formatTime(total));
    }, 1000);
  };

  const stopTimer = () => {
    clearInterval(intervalRef.current);
  };
  //checkin checkout logic end

  const filteredLabels = [];
  const filteredData = [];
  const backgroundColors = [];
  const hoverBackgroundColors = [];

  leaveCount?.map((item, index) => {
    console.log(item, "item");

    if (
      item?.leaveType !== "loss_of_pay" &&
      item?.leaveType !== "paternity_leave" &&
      item?.leaveType !== "maternity_leave" &&
      item?.leaveType !== "work_from_home"
    ) {
      filteredLabels.push(
        item?.leaveType == "restricted_holiday"
          ? "Restricted Holiday"
          : item?.leaveType == "casual_leave"
          ? "Casual Leave"
          : item?.leaveType == "earned_leave"
          ? "Earned Leave"
          : item?.leaveType == "sick_leave"
          ? "Sick Leave"
          : item?.leaveType
      );
      filteredData.push(item?.remaining);
      backgroundColors.push(
        ["#FF6384", "#36A2EB", "#FFCE56", "#36ba45"][index % 4]
      );
      hoverBackgroundColors.push(
        ["#FF6384", "#36A2EB", "#FFCE56", "#36ba45"][index % 4]
      );
    }
  });

  const pieData = {
    labels: filteredLabels,
    datasets: [
      {
        label: "Leave Details",
        data: filteredData,
        backgroundColor: backgroundColors,
        hoverBackgroundColor: hoverBackgroundColors,
      },
    ],
  };

  const pieOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "right",
        labels: {
          font: {
            size: 14,
          },
        },
      },
    },
  };

  const fetchEmployeeDor = async () => {
    const query = `
          query GetEmployeeLeaveDashboard { 
              employeeLeaveDashboard { 
                  employeeName 
                  leaveStartDate 
                  leaveEndDate 
                  primaryDelegate 
                  secondaryDelegate 
                  delegateEmployeeName 
                  assignedTasks 
              } 
          }`;

    try {
      const response = await axios.post(
        BASEURL,
        { query },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      const data = response.data.data?.employeeLeaveDashboard || [];

      const mappedData = data.map((item) => ({
        employeeName: item.employeeName || "N/A",
        primaryDelegate: item.primaryDelegate || "Not Assigned",
        secondaryDelegate: item.secondaryDelegate || "Not Assigned",
        assignedTasks:
          item.assignedTasks?.length > 0
            ? item.assignedTasks
            : "No Tasks Assigned",
      }));

      setDor(mappedData);
    } catch (error) {
      console.error("Unable to fetch Data", error);
    }
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "firstName", headerName: "First name", width: 130 },
    { field: "lastName", headerName: "Last name", width: 130 },
    {
      field: "age",
      headerName: "Age",
      type: "number",
      width: 90,
    },
    {
      field: "fullName",
      headerName: "Full name",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 160,
      valueGetter: (value, row) =>
        `${row.firstName || ""} ${row.lastName || ""}`,
    },
  ];

  const newBoxShadow = "0 6px 30px rgba(182, 186, 203, 0.3)";

  const MangerData = `
  query ManagerDashboard($userId: ID!, $teamleader: String!) {
  totalLeaveConfigurations
  approvedLeavesWithoutLop(userId: $userId)
  approvedLeavesWithLop(userId: $userId)
  pendingLeavesCount(userId: $userId)
  pendingRequestsCounts(teamleader: $teamleader) {
    pendingLeaveCount
    pendingWfhCount
    pendingRegularizationCount
  }
  teamSummary(teamleader: $teamleader) {
    attendanceCount
    leaveCount
    wfhCount
  }
  birthdayUsers {
    firstName
    department
  }
  teamMemberDetails(teamleader: $teamleader) {
    firstName
    presentStatus
    leaveStatus
    wfhStatus
    checkInTime
    checkOutTime
  }
}
`;
  const handeldatas = async () => {
    const data = sessionStorage.getItem("user");
    const parsedData = JSON.parse(data);
    const encodedId = btoa(parsedData?.id);
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: MangerData,
          variables: {
            userId: parsedData?.id,
            teamleader: parsedData?.id,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = response?.data?.data;
      setData(data);
      setbirthday(data?.birthdayUsers);
      setTeams(data?.teamMemberDetails);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  const leaveCountByUser = `
  query leavedetailbyme($id:String!){
  leaveDetailsByMe(id: $id){
    user{
      email
    }
    status
    takedLeave
    leaveType {
      id
      name
    }
    leaveCount
    workFromHome
  }
}
  `;
  const leavecount = async () => {
    const data = sessionStorage.getItem("user");
    const parsedData = JSON.parse(data);
    const encodedId = btoa(parsedData?.id);
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: leaveCountByUser,
          variables: { id: parsedData?.id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data.data.leaveDetailsByMe;

      let filterdata = data.filter(
        (val) => val.leaveType.name !== "loss_of_pay"
      );

      const remainingLeaves = filterdata.map((item) => ({
        leaveType: item.leaveType.name,
        remaining: item.leaveCount - item.takedLeave,
      }));
      setLeaveCount(remainingLeaves);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };
  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };
  const getLatestAttendanceData = (data) => {
    const latestData = {};
    data?.forEach((item) => {
      const date = new Date(item.checkIn || item.checkOut)
        .toISOString()
        .slice(0, 10);
      if (
        !latestData[date] ||
        new Date(item.lastUpdate) > new Date(latestData[date].lastUpdate)
      ) {
        latestData[date] = item;
      }
    });
    return Object.values(latestData);
  };
  const filteredAttendanceData = getLatestAttendanceData(attendanceData).filter(
    (item) => {
      const date = new Date(item.checkIn);
      return (
        date.getFullYear() === parseInt(selectedYear) &&
        date.getMonth() + 1 === parseInt(selectedMonth) &&
        item.checkIn &&
        !item.checkOut // Only include entries with checkIn but no checkOut
      );
    }
  );
  const attendanceQuery = `
  query userAttendanceDetails($id: String!) {
    userAttendanceDetails(id: $id) {
      data
      {
      id
      checkIn
      checkOut
      totalWorkingHours
      }
    
    }
  }
`;
  const fetchAttendanceData = async () => {
    const data = sessionStorage.getItem("user");
    const parsedData = JSON.parse(data);
    const encodedId = btoa(parsedData?.id);

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: attendanceQuery,
          variables: { id: parsedData?.id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setAttendanceData(response.data?.data?.userAttendanceDetails?.data);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  return (
    <DashboardLayout isCheckedIn={isCheckedIn}>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      {birthpopup && (
        <Dialog
          maxWidth="sm"
          fullWidth
          // {...rest}
          open={true}
        >
          <DialogTitle>
            <Typography
              variant="body1"
              sx={{
                fontWeight: "bold",
                color: "#6a1b9a",
                fontSize: "0.95rem",
              }}
            >
              Birthday Celebrations For Today🎉
            </Typography>
          </DialogTitle>

          <DialogContent variant="body2">
            {birthday.map((person, index) => (
              <Box
                key={index}
                sx={{
                  marginBottom: 1,
                  padding: 1,
                  borderRadius: 1,
                  backgroundColor: index % 2 === 0 ? "#f3e5f5" : "#ede7f6",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: "bold",
                    color: "#6a1b9a",
                    fontSize: "0.95rem",
                  }}
                >
                  {person.firstName}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: "0.85rem" }}
                >
                  {person.department}
                </Typography>
              </Box>
            ))}
          </DialogContent>

          <DialogActions>
            <MaterialButton
              color="error"
              variant="text"
              onClick={() => setBirthdayPopup(false)}
            >
              Cancel
            </MaterialButton>
          </DialogActions>
        </Dialog>
      )}
      {stsTabel && (
        <Dialog
          maxWidth="sm"
          fullWidth
          // {...rest}
          open={true}
        >
          <DialogTitle>
            <Typography
              variant="body1"
              sx={{
                fontWeight: "bold",
                color: "#6a1b9a",
                fontSize: "0.95rem",
              }}
            >
              Status Table
            </Typography>
          </DialogTitle>

          <DialogContent variant="body2">
            <div className="tabel-target">
              <table
                border="1"
                cellPadding="10"
                cellSpacing="0"
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  border: "none",
                }}
              >
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Status</th>
                    <th>CheckIn</th>
                    <th>CheckOut</th>
                  </tr>
                </thead>
                <tbody>
                  {teams.map((item, ind) => {
                    return (
                      <tr>
                        <td>{item?.firstName}</td>
                        <td>
                          {item?.leaveStatus ? (
                            <div
                              style={{
                                backgroundColor: "red",
                                borderRadius: "15px",
                                textAlign: "center",
                                marginLeft: "-8px",
                                color: "white",
                              }}
                            >
                              Leave
                            </div>
                          ) : item?.presentStatus ? (
                            <div
                              style={{
                                backgroundColor: "green",
                                borderRadius: "15px",
                                textAlign: "center",
                                marginLeft: "-8px",
                                color: "white",
                              }}
                            >
                              Present
                            </div>
                          ) : item?.wfhStatus ? (
                            <div
                              style={{
                                backgroundColor: "blue",
                                borderRadius: "15px",
                                textAlign: "center",
                                marginLeft: "-8px",
                                color: "white",
                              }}
                            >
                              WFH
                            </div>
                          ) : (
                            "N/A"
                          )}
                        </td>
                        <td>{item?.checkInTime ? item.checkInTime : "N/A"}</td>
                        {/* <td>{item?.checkInTime? moment(item.checkInTime).format("hh:mm A"):"N/A"}</td> */}
                        <td>
                          {item?.checkOutTime ? item.checkOutTime : "N/A"}
                        </td>
                        {/* <td>{item?.checkOutTime? moment(item.checkOutTime).format("hh:mm A"):"N/A"}</td> */}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </DialogContent>

          <DialogActions>
            <MaterialButton
              color="error"
              variant="text"
              onClick={() => setStsTable(false)}
            >
              Cancel
            </MaterialButton>
          </DialogActions>
        </Dialog>
      )}
      <Box sx={{ padding: 1 }}>
        <Grid2 container spacing={2}>
          {/* Mark Attendance Card */}

          <Grid2 size={{ xs: 12, sm: 6, lg: 6 }}>
            <Card
              elevation={3}
              sx={{
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: 2,
                padding: 0.5,
                height: 269,
              }}
            >
              <CardContent>
                {/* Title */}
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ fontWeight: "bold", marginBottom: 2 }}
                >
                  Mark Attendance
                </Typography>

                {/* Timer Section */}
                <Box
                  sx={{
                    backgroundColor: "#fff5ec",
                    borderRadius: 2,
                    padding: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Box>
                    <Typography sx={{ color: "#4d5154", fontSize: "15px" }}>
                      Working Hours
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "500",
                        color: "#373b3e",
                        fontSize: "20px",
                      }}
                    >
                      {ischeckIn ? displayTime : "00:00:00"}
                    </Typography>
                  </Box>
                  <Button
                    variant="gradient"
                    sx={{
                      backgroundColor: ischeckIn ? "#fc133d" : "#ffa726",
                      color: "#fff",
                      fontWeight: "bold",
                      marginTop: "20px",
                      marginLeft: "5px",
                    }}
                    onClick={ischeckIn ? handleClockOut : handleCheckIn}
                  >
                    {ischeckIn ? "Clock-Out" : "Clock-In"}
                  </Button>
                </Box>

                {ischeckIn ? (
                  <Typography
                    sx={{
                      color: "#4d5154",
                      fontSize: "15px",
                      marginTop: "10px",
                    }}
                  >
                    {/* Clock In: {moment(checkInTime).format("hh:mm A")} */}
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      color: "#4d5154",
                      fontSize: "15px",
                      marginTop: "10px",
                    }}
                  >
                    Last Clock Out: {checkOutTime !== "00:00:00" ? moment(checkOutTime).format("hh:mm A") : "00:00:00"}
                  </Typography>
                )}

                <Box sx={{ borderBottom: "1px solid #d3d3d4" }}></Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#373b3e",
                    cursor: "pointer",
                    fontWeight: "500",
                    marginTop: "5%",
                    "&:hover": {
                      color: "#3F51B5d4",
                    },
                  }}
                  onClick={() => navigate("/calendar")}
                >
                  View Attendance
                </Typography>
              </CardContent>
            </Card>
          </Grid2>

          {/* Attendance & Leaves Card */}
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <Card
              elevation={3}
              sx={{
                borderRadius: 2,
                boxShadow: newBoxShadow,
                padding: 1,
                minHeight: 269,
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ fontWeight: "bold", fontSize: "1rem" }}
                >
                  Attendance & Leaves
                </Typography>
                <Grid container spacing={1.8}>
                  {[
                    {
                      title: "Total Leaves",
                      value: totalLeaveCount,
                      color: "#ff902f",
                    },
                    {
                      title: "Leaves Taken",
                      value: dates?.approvedLeavesWithoutLop,
                      color: "#fc6075",
                    },
                    // { title: "Leaves Absent", value: 6.5, color: "#36ba45" },
                    {
                      title: "Pending Approval",
                      value: dates?.pendingLeavesCount,
                      color: "#9368e9",
                    },
                    // { title: "Working Days", value: 6.5, color: "#009efb" },
                    {
                      title: "Loss of Pay",
                      value: dates?.approvedLeavesWithLop,
                      color: "#fc133d",
                    },
                  ].map((stat, index) => (
                    <Grid item xs={4} sm={4} key={index}>
                      <Typography
                        variant="h5"
                        align="center"
                        sx={{
                          fontWeight: "bold",
                          color: stat.color,
                          mb: 0.25,
                        }}
                      >
                        {stat.value}
                      </Typography>
                      <Typography
                        variant="body2"
                        align="center"
                        sx={{
                          fontSize: "14px",
                          color: "#4d5154",
                          fontWeight: 500,
                        }}
                      >
                        {stat.title}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>

                <Box
                  sx={{
                    borderBottom: "1px solid #d3d3d4",
                    my: 1,
                    marginTop: 3,
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    color: "#373b3e",
                    cursor: "pointer",
                    fontWeight: "500",
                    marginTop: "3%",
                    "&:hover": {
                      color: "#3F51B5d4",
                    },
                  }}
                  onClick={() =>
                    navigate("/apply-leave/apply-leaverequest")
                  }
                >
                  Apply Leaves
                </Typography>
              </CardContent>
            </Card>
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
            <Card
              elevation={3}
              sx={{
                borderRadius: 2,
                padding: 1,
              }}
            >
              <CardContent>
                {/* Title */}
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "#333",
                    mb: 2,
                  }}
                >
                  Team Status
                </Typography>

                {[
                  {
                    title: "Present",
                    value: dates?.teamSummary?.attendanceCount,
                    color: "#36ba45",
                  },
                  {
                    title: "WFH",
                    value: dates?.teamSummary?.wfhCount,
                    color: "#ffa726",
                  },
                  {
                    title: "Absent",
                    value: dates?.teamSummary?.leaveCount,
                    color: "#fc133d",
                  },
                ].map((item, index) => (
                  <Box key={index} sx={{ marginBottom: 1.7 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#4d5154",
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: item.color,
                        }}
                      >
                        {item.value}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        width: "100%",
                        height: "10px",
                        borderRadius: "5px",
                        backgroundColor: "#e0e0e0",
                      }}
                    >
                      <Box
                        sx={{
                          width: `${(item.value / 10) * 100}%`,
                          height: "100%",
                          borderRadius: "5px",
                          backgroundColor: item.color,
                        }}
                      />
                    </Box>
                  </Box>
                ))}
                <Box sx={{ borderBottom: "1px solid #d3d3d4", my: 2 }} />
                <Typography
                  variant="body2"
                  sx={{
                    color: "#373b3e",
                    cursor: "pointer",
                    fontWeight: "500",
                    marginTop: "3%",
                    "&:hover": {
                      color: "#3F51B5d4",
                    },
                  }}
                  onClick={() => setStsTable(true)}
                >
                  View Teammates
                </Typography>
              </CardContent>
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
            <Card
              sx={{
                borderRadius: 2,
                boxShadow: "0 3px 8px rgba(0, 0, 0, 0.2)",
                backgroundColor: "#f9f4ff",
                padding: 1,
                minHeight: 295, // Adjusted height for a more compact look
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Avatar
                    sx={{
                      width: 40,
                      height: 40,
                      marginRight: 1,
                      backgroundColor: "#8e44ad",
                      color: "#fff",
                      fontSize: "1.2rem", // Smaller font size for the emoji
                    }}
                  >
                    🎂
                  </Avatar>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "600",
                      color: "#4a148c",
                      fontSize: "18px", // Slightly smaller title font
                    }}
                  >
                    Today’s Birthdays
                  </Typography>
                </Box>
                {birthday?.length == 1 ? (
                  <Box
                    // key={}
                    sx={{
                      marginBottom: 1,
                      padding: 1,
                      borderRadius: 1,
                      backgroundColor: "#ede7f6",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: "bold",
                        color: "#6a1b9a",
                        fontSize: "0.95rem",
                      }}
                    >
                      {birthday?.[0]?.firstName}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ fontSize: "0.85rem" }}
                    >
                      {birthday?.[0]?.department}
                    </Typography>
                  </Box>
                ) : birthday?.length > 1 ? (
                  <>
                    <Box
                      // key={}
                      sx={{
                        marginBottom: 1,
                        padding: 1,
                        borderRadius: 1,
                        backgroundColor: "#ede7f6",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: "bold",
                          color: "#6a1b9a",
                          fontSize: "0.95rem",
                        }}
                      >
                        {birthday?.[0]?.firstName}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontSize: "0.85rem" }}
                      >
                        {birthday?.[0]?.department}
                      </Typography>
                    </Box>
                    <Box
                      // key={}
                      sx={{
                        marginBottom: 1,
                        padding: 1,
                        borderRadius: 1,
                        backgroundColor: "#f3e5f5",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: "bold",
                          color: "#6a1b9a",
                          fontSize: "0.95rem",
                        }}
                      >
                        {birthday?.[1]?.firstName}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontSize: "0.85rem" }}
                      >
                        {birthday?.[1]?.department}
                      </Typography>
                    </Box>
                  </>
                ) : (
                  <Box
                    // key={}
                    sx={{
                      marginTop: 8,
                      padding: 1,
                      borderRadius: 1,
                      backgroundColor: "#f3e5f5",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: "bold",
                        color: "#6a1b9a",
                        fontSize: "0.95rem",
                      }}
                    >
                      No Birthday
                    </Typography>
                  </Box>
                )}
                {birthday?.length > 2 && (
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#373b3e",
                      cursor: "pointer",
                      fontWeight: "500",
                      marginTop: "3%",
                      "&:hover": {
                        color: "#3F51B5d4",
                      },
                    }}
                    onClick={() => {
                      setBirthdayPopup(true);
                    }}
                  >
                    See Birthdays
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
            <Card
              elevation={2}
              sx={{
                borderRadius: 2,
                padding: 1,
                backgroundColor: "#fff",
                boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
                minHeight: 295,
              }}
            >
              <CardContent>
                {/* Title */}
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    marginBottom: 1,
                    //   textAlign: "center",
                    fontSize: "1rem",
                  }}
                >
                  Pending Approvals
                </Typography>

                {/* Approval Categories */}
                {[
                  {
                    title: "Leaves",
                    count: dates?.pendingRequestsCounts?.pendingLeaveCount,
                    color: "#007bff",
                    navigates: "/apply-leave",
                  },
                  {
                    title: "WFH",
                    count: dates?.pendingRequestsCounts?.pendingWfhCount,
                    color: "#28a745",
                    navigates: "/wfh-management",
                  },
                  {
                    title: "Regularization",
                    count:
                      dates?.pendingRequestsCounts?.pendingRegularizationCount,
                    color: "#ffc107",
                    navigates: "/regularization-request",
                  },
                ].map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: 1,
                      padding: "4px",
                      backgroundColor: "#f8f9fa",
                      borderRadius: 1,
                    }}
                  >
                    {/* Category Info */}
                    <Box>
                      <Typography
                        sx={{
                          fontSize: "0.85rem",
                          fontWeight: "bold",
                          color: "#4d5154",
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "1rem",
                          fontWeight: "bold",
                          color: item.color,
                        }}
                      >
                        {item.count}
                      </Typography>
                    </Box>

                    {/* Action Button */}
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        backgroundColor: item.color,
                        color: "#fff",
                        fontWeight: "bold",
                        textTransform: "capitalize",
                        paddingX: 1.5,
                        paddingY: 0.5,
                        borderRadius: 2,
                        fontSize: "0.75rem",
                        "&:hover": {
                          backgroundColor: item.color,
                          opacity: 0.9,
                        },
                      }}
                      onClick={() => navigate(item?.navigates)}
                    >
                      Action
                    </Button>
                  </Box>
                ))}

                {/* Description */}
              </CardContent>
            </Card>
          </Grid2>
          {/* Team Summary Card */}

          <Grid2 size={{ xs: 12, sm: 6 }}>
            <Card
              elevation={3}
              sx={{
                borderRadius: 2,
                // border: "1px solid #d5dbdb",
                boxShadow: newBoxShadow,
                padding: 1,
                height: 269,
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ fontWeight: "bold" }}
                >
                  Available Leave & WFH
                </Typography>
                <div style={{ marginTop: "3%" }}>
                  <Doughnut
                    height={"192px"}
                    data={pieData}
                    options={pieOptions}
                  />
                </div>
              </CardContent>
            </Card>
          </Grid2>
          {/* Attendance & Leaves Card */}

          <Grid2 size={{ xs: 12, sm: 6 }}>
            <Card
              elevation={3}
              sx={{
                boxShadow: newBoxShadow,
                borderRadius: 2,
                padding: 2,
                height: 269,
              }}
            >
              <CardContent>
                {/* Title and Select Boxes Section */}
                <div
                  style={{
                    // display: "flex",
                    // justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "56px",
                    // Added space below the title and selects
                  }}
                >
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    Missing Check-Out Days
                  </Typography>
                  <div
                    style={{ display: "flex", gap: "16px", marginTop: "10px" }}
                  >
                    <div>
                      <select
                        value={selectedYear}
                        onChange={handleYearChange}
                        style={{
                          width: "190px",
                          border: "1px solid gray",
                          textAlign: "center",
                          padding: "10px",
                          borderRadius: "5px",
                          color: "#3F51B5d4",
                          paddingRight: "3px",
                          outline: "none",
                        }}
                      >
                        {Array.from({ length: 10 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </select>
                      <select
                        style={{
                          width: "190px",
                          border: "1px solid gray",
                          textAlign: "center",
                          padding: "10px",
                          borderRadius: "5px",
                          color: "#3F51B5d4",
                          marginLeft: "6px",
                          outline: "none",
                        }}
                        value={selectedMonth}
                        onChange={handleMonthChange}
                        className="border rounded p-2"
                      >
                        {Array.from({ length: 12 }, (_, i) => (
                          <option key={i + 1} value={i + 1}>
                            {new Date(0, i).toLocaleString("default", {
                              month: "long",
                            })}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {filteredAttendanceData.length > 0 ? (
                    <div>
                      {filteredAttendanceData.map((entry, index) => (
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <MiniCard>
                            Date: {new Date(entry.checkIn).toLocaleDateString()}
                          </MiniCard>

                          <MiniCard>
                            Check In:{" "}
                            {entry.checkIn
                              ? new Date(entry.checkIn).toLocaleTimeString()
                              : "N/A"}
                          </MiniCard>

                          <MiniCard>
                            Check Out:{" "}
                            {entry.checkOut
                              ? new Date(entry.checkOut).toLocaleTimeString()
                              : "N/A"}
                          </MiniCard>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        marginTop: "20px",
                        color: "#373b3e",
                      }}
                    >
                      No attendance data found without checkout for the selected
                      data.
                    </Typography>
                  )}
                </div>
              </CardContent>
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <Card
              elevation={3}
              sx={{
                borderRadius: 2,
                boxShadow: newBoxShadow,
                padding: 1,
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    marginBottom: 0,
                    padding: 1,
                    fontSize: "1rem",
                  }}
                >
                  DOR
                </Typography>
              </CardContent>
              <TableContainer>
                <Table>
                  <TableHead
                    sx={{
                      height: "427px",
                      paddingLeft: "30px",
                      marginTop: "-16px",
                    }}
                  >
                    <TableRow sx={{ backgroundColor: "#def6e3" }}>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: "#28a745",
                          fontSize: "0.875rem",
                        }}
                      >
                        Employee
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: "#28a745",
                          fontSize: "0.875rem",
                        }}
                      >
                        Primary DOR
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: "#28a745",
                          fontSize: "0.875rem",
                        }}
                      >
                        Secondary DOR
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: "#28a745",
                          fontSize: "0.875rem",
                        }}
                      >
                        Task
                      </TableCell>
                    </TableRow>
                    <TableBody>
                      {dor
                        ?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => (
                           <TableRow key={index}>
                            <TableCell sx={{ fontSize: "0.75rem" }}>
                              {row.employeeName}
                            </TableCell>
                            <TableCell sx={{ fontSize: "0.75rem" }}>
                              {row.primaryDelegate}
                            </TableCell>
                            <TableCell sx={{ fontSize: "0.75rem" }}>
                              {(row?.secondaryDelegate) || "N/A"}
                            </TableCell>
                            <TableCell sx={{ fontSize: "0.75rem" }}>
                              {row?.assignedTasks
                                ? (row?.assignedTasks)
                                : "N/A"}
                            </TableCell>
                          </TableRow>
                        ))}
                      {/* Handle Empty Data */}
                      {dor?.length === 0 && (
                        <TableRow>
                          <TableCell colSpan={4} align="center">
                            No Data Available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </TableHead>
                </Table>
              </TableContainer>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "8px 16px",
                  backgroundColor: "#f9f9f9",
                }}
              >
                <TablePagination
                  rowsPerPageOptions={[10]}
                  component="div"
                  count={dor?.length || 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={({
                    count,
                    page,
                    rowsPerPage,
                    onPageChange,
                  }) => (
                    <Box sx={{ flexShrink: 0 }}>
                      <IconButton
                        onClick={(event) => onPageChange(event, page - 1)}
                        disabled={page === 0}
                      >
                        <ChevronLeft />
                      </IconButton>
                      <IconButton
                        onClick={(event) => onPageChange(event, page + 1)}
                        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                      >
                        <ChevronRight />
                      </IconButton>
                    </Box>
                  )}
                />
              </Box>
            </Card>
          </Grid2>
        </Grid2>
      </Box>
    </DashboardLayout>
  );
};

export default Mangerdashboard;
